// Local translations
export const T = {
  en_GB: {
    xrayAccessRequired: "Portfolio X-Ray Access Required",
    xrayAccessMessage:
      "Your organization does not have access to Morningstar Portfolio X-Ray features. This component will not display data in PDFs until the feature is enabled.",
    contactAdmin: "Contact your administrator to enable this feature.",
    title: "Title (optional)",
    titlePlaceholder: "e.g., Asset Allocation",
    titleHelp: "Optional heading to display above the X-Ray data",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and content",
    displayMode: "Display Mode",
    displayModeHelp: "Choose which data to display from the X-Ray analysis",
    assetAllocation: "Asset Allocation",
    countryExposure: "Country Exposure (Top 10)",
    regionalExposure: "Regional Exposure",
    stockSector: "Stock Sector",
    equityStyle: "Equity Style Box",
    bondSector: "Bond Sector",
    topHoldings: "Top 10 Holdings",
    showChart: "Show Chart",
    showChartHelp: "Display pie chart visualization",
    showTable: "Show Table",
    showTableHelp: "Display data table with allocation percentages",
    enableFollowupComparison: "Enable comparison in follow up sessions",
    enableFollowupComparisonHelp:
      "Show existing vs modified portfolio side-by-side when the session is a followup",
    validationError: "At least one display option must be selected",
    validationErrorLong: "At least one display option (Chart or Table) must be selected",
  },
  nb_NO: {
    xrayAccessRequired: "Portfolio X-Ray-tilgang kreves",
    xrayAccessMessage:
      "Din organisasjon har ikke tilgang til Morningstar Portfolio X-Ray-funksjoner. Denne komponenten vil ikke vise data i PDF-er før funksjonen er aktivert.",
    contactAdmin: "Kontakt administratoren for å aktivere denne funksjonen.",
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Aktivaallokering",
    titleHelp: "Valgfri overskrift som vises over X-Ray-dataene",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og innholdet",
    displayMode: "Visningsmodus",
    displayModeHelp: "Velg hvilke data som skal vises fra X-Ray-analysen",
    assetAllocation: "Aktivaallokering",
    countryExposure: "Landeksponering (Topp 10)",
    regionalExposure: "Regional eksponering",
    stockSector: "Aksjesektor",
    equityStyle: "Aksjestilboks",
    bondSector: "Obligasjonssektor",
    topHoldings: "Topp 10 beholdninger",
    showChart: "Vis diagram",
    showChartHelp: "Vis sektordiagram",
    showTable: "Vis tabell",
    showTableHelp: "Vis datatabell med allokeringsprosenter",
    enableFollowupComparison: "Aktiver sammenligning i oppfølgingsøkter",
    enableFollowupComparisonHelp:
      "Vis eksisterende og endret portefølje side om side når økten er en oppfølging",
    validationError: "Minst ett visningsalternativ må være valgt",
    validationErrorLong: "Minst ett visningsalternativ (diagram eller tabell) må være valgt",
  },
} as const;
